<template>
  <div>
    <div style="margin-top: 15%">
      <span class="not-found">404</span>
      <h1>Página no encontrada 😔</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "not-found",
  mounted() {
    this.$store.commit("setNavBar", true);
  },
};
</script>

<style>
.not-found {
  font-size: 100px;
  color: #f06a25;
}
</style>